import React from "react";
import WorkoutCompleted from '../PlayerAndCorousel/views/Player/WorkOutCompleted'


function ClassCompleted(props) {
    const { navigate } = props;
    return (
        <React.Fragment>
                <WorkoutCompleted class="workOutCompleted p-lr-xs-15" elapsedTime={props.duration} workOutCompleteHandler={() => navigate(-1)} />
        </React.Fragment>

    );
}

export default ClassCompleted;  